<template>
  <div class="accordion">
    <div
      class="accordion__title"
      @click="toggleAccordion"
    >
      <span>
        <ag-icon
          icon="chevron-down"
          :style="{
            transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)'
          }"
        ></ag-icon>
        {{title}}
      </span>
    </div>

    <div
      class="accordion__text"
      :class="{'accordion__text--selected': isOpen}"
      :style="{
          maxHeight: isOpen ? maxHeight+'px' : '0',
          marginTop: isOpen ? '20px' : '0'
      }"
      ref="textContent"
    >
      <slot />
    </div>
  </div>
</template>

<script>
import { defineComponent, onMounted, ref } from '@vue/composition-api'

export default defineComponent({
  props: {
    title: {
      type: String,
      required: true,
    },
  },
  setup() {
    const isOpen = ref(false)
    const textContent = ref(null)
    const maxHeight = ref(0)

    const toggleAccordion = () => {
      isOpen.value = !isOpen.value
    }

    onMounted(() => {
      maxHeight.value = textContent.value.scrollHeight
    })

    return {
      textContent,
      isOpen,
      maxHeight,
      toggleAccordion,
    }
  },
})
</script>
